(function(app) {

    app.provider("salesForceApi",
    [
        function() {
            this.$get = [
                "complianceHubApiGateway", function(complianceHubApiGateway) {
                    var service = {};

                    service.getExternalSfAdvisor = function (userId) {
                        return complianceHubApiGateway.get("/SalesForce/GetExternalSfAdvisor/" + userId);
                    };

                    service.getExternalSfAdvisorRegistration = function (userRegistrationId) {
                        return complianceHubApiGateway.get("/SalesForce/GetExternalSfAdvisorRegistration/" + userRegistrationId);
                    };
                                                   
                    service.getExternalSfClient = function (transactionId) {
                        return complianceHubApiGateway.get("/SalesForce/GetExternalSfClient/Transaction/" + transactionId);
                    };   
                                       
                    service.createExternalSfClientRecord = function (client) {
                        return complianceHubApiGateway.post("/SalesForce/CreateExternalSfClientRecord", client);
                    }; 
                    
                    service.createExternalSfAdvisorRecord = function (agent) {
                        return complianceHubApiGateway.post("/SalesForce/CreateExternalSfAgentRecord", agent);
                    }; 

                    service.createExternalSfAdvisorRegistrationRecord = function (agent) {
                        return complianceHubApiGateway.post("/SalesForce/CreateExternalSfAgentRegistrationRecord", agent);
                    }; 

                    service.updateExternalSfAdvisorRecord = function (agent) {
                        return complianceHubApiGateway.put("/SalesForce/UpdateExternalSfAgentRecord", agent);
                    }; 

                    service.deleteExternalSfAdvisorRecord = function (userId) {
                        return complianceHubApiGateway.delete("/SalesForce/DeleteExternalSfAgentRecord/" + userId);
                    }; 

                    service.deleteExternalSfAdvisorRegistrationRecord = function (userRegistrationId) {
                        return complianceHubApiGateway.delete("/SalesForce/DeleteExternalSfAgentRegistrationRecord/" + userRegistrationId);
                    }; 
                 
                    return service;
                }
            ];
        }
    ]);
})(window.app);